import { put, takeEvery, call } from "redux-saga/effects";
import * as actionTypes from "./constants";
import endpoints from "../endpoints";
// import { appConfig } from "../../config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import api from "../api";
import fmApi from "../APIWrapper";

// function* commonFunction(value) {
//   const token = localStorage.getItem("fmsToken");
//   try {
//     const res = yield fetch(`${value.api}`, {
//       method: `${value.method}`,
//       headers: {
//         Accept: "application/json",
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//         type: "Web",
//       },
//       body: value.body ? value.body : null,
//     });

//     if (!res.ok) {
//       throw res;
//     } else {
//       const resJSON = yield res.json();

//       yield put({
//         type: `${value.sucessAction}`,
//         payload: resJSON,
//       });
//       yield put({
//         type: `${value.initAction}`,
//       });

//       yield toast.success(value.toastMsg, {
//         autoClose: 3000,
//       });
//       return resJSON;
//     }
//   } catch (err) {
//     if (err.ok === false) {
//       yield put({ type: `${value.failAction}`, error: err });
//     } else {
//     }
//   }
// }

// 


function* fetchRwaMember() {
  const societyId = JSON.parse(localStorage.getItem("FmsUser")).society_id;
  const data = {
    societyId: societyId,
  };
  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/apartmentinfoservice/society/getrwamembers`,
    //   method: "POST",
    //   sucessAction: actionTypes.FETCH_RWAMEMBER_SUCCESS_ACTION,
    //   failAction: actionTypes.FETCH_RWAMEMBER_FAIL_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const res = yield call(api.commonGetFunction, params);
    // if (res) {
    // }

    const resJSON = yield call(fmApi.FetchRwaMembersApi, data);
    yield put({
      type: actionTypes.FETCH_RWAMEMBER_SUCCESS_ACTION,
      payload: resJSON,
    });
    // }
  } catch (err) {
    if (err.status === 401) {
    }
    yield put({
      type: actionTypes.FETCH_RWAMEMBER_FAIL_ACTION,
      payload: err,
    });
  }
}

function* addrwaMemberData(values) {
  const societyId = JSON.parse(localStorage.getItem("FmsUser")).society_id;
  let data = {
    societyId: societyId,
    members: values.value,
  };
  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/apartmentinfoservice/society/insertrwamembers`,
    //   method: "POST",
    //   sucessAction: actionTypes.ADD_RWAMEMBER_SUCCESS_ACTION,
    //   toastMsg: "RWA Member added successfully",
    //   initAction: actionTypes.FETCH_RWAMEMBER_INIT_ACTION,
    //   failAction: actionTypes.ADD_RWAMEMBER_FAIL_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(commonPostFunction, params);

    // return Res;
    const resJSON = yield call(fmApi.PostInsertRwaMembersApi, data);

    yield put({
      type: actionTypes.ADD_RWAMEMBER_SUCCESS_ACTION,
      payload: resJSON,
    });
    yield put({
      type: actionTypes.FETCH_RWAMEMBER_INIT_ACTION,
    });
    yield toast.success("RWA Member added successfully", {
      autoClose: 3000,
    });

    return resJSON;
  } catch (err) {
    if (err.ok === false) {
      if (err.status === 400) {
        yield put({
          type: actionTypes.ADD_RWAMEMBER_FAIL_ACTION,
          error: err,
        });
        yield toast.error(`${endpoints.status400}`);
      } else if (err.status === 500) {
        yield put({
          type: actionTypes.ADD_RWAMEMBER_FAIL_ACTION,
          error: err,
        });
        yield toast.error(`${endpoints.status500}`);
      } else {
      }
    }
  }
}

function* deleteItems(value) {
  // const token = localStorage.getItem("fmsToken");
  let data = {
    contactId: value.value,
  };
  try {
    // const res = yield fetch(
    //   `${appConfig.urlPrefixIp}/apartmentinfoservice/society/deleterwamember`,
    //   {
    //     method: "POST",
    //     headers: {
    //       Accept: "application/json",
    //       "Content-Type": "application/json",
    //       Authorization: `Bearer ${token}`,
    //       type: "Web",
    //     },
    //     body: JSON.stringify(data),
    //   }
    // );
    // if (!res.ok) {
    //   throw res;
    // } else {
    //   const resJSON = yield res.json();
    const resJSON = yield call(fmApi.DeleteRwaMembersApi, data);

    yield put({
      type: actionTypes.DELETE_RWAMEMBER_SUCCESS_ACTION,
      payload: { resJSON: resJSON, contactId: value.value },
    });
    toast.success("RWA member deleted successfully.");
    return resJSON;
    // }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.DELETE_RWAMEMBER_FAIL_ACTION,
        error: err,
      });

      if (err.status === 400) {
        yield toast.error(`${endpoints.status400}`, {
          autoClose: 3000,
        });
      } else if (err.status === 500) {
        yield toast.error(`${endpoints.status500}`, {
          autoClose: 3000,
        });
      } else {
      }
    }
  }
}

function* updateRwaMember(value) {
  let data = {
    name: value.value.name,
    contactId: value.value.contactId,
    designation: value.value.designation,
    start: value.value.start,
    end: value.value.end,
  };
  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/apartmentinfoservice/society/updaterwamember`,
    //   method: "POST",
    //   sucessAction: actionTypes.UPDATE_RWAMEMBER_SUCCESS_ACTION,
    //   toastMsg: "RWA member updated successfully.",
    //   initAction: actionTypes.FETCH_RWAMEMBER_INIT_ACTION,
    //   failAction: actionTypes.UPDATE_RWAMEMBER_FAIL_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(commonPostFunction, params);
    // return Res;
    const resJSON = yield call(fmApi.UpdateRwaMembersApi, data);

    yield put({
      type: actionTypes.UPDATE_RWAMEMBER_SUCCESS_ACTION,
      payload: resJSON,
    });
    yield put({
      type: actionTypes.FETCH_RWAMEMBER_INIT_ACTION,
    });
    yield toast.success("RWA member updated successfully", {
      autoClose: 3000,
    });
    return resJSON;
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.UPDATE_RWAMEMBER_FAIL_ACTION,
        error: err,
      });

      if (err.status === 400) {
        yield toast.error(`${endpoints.status400}`, {
          autoClose: 3000,
        });
      } else if (err.status === 500) {
        yield toast.error(`${endpoints.status500}`, {
          autoClose: 3000,
        });
      } else {
      }
    }
  }
}

export function* rwaMemberActionWatcher() {
  yield takeEvery(actionTypes.FETCH_RWAMEMBER_INIT_ACTION, fetchRwaMember);
  yield takeEvery(actionTypes.ADD_RWAMEMBER_INIT_ACTION, addrwaMemberData);
  yield takeEvery(actionTypes.DELETE_RWAMEMBER_INIT_ACTION, deleteItems);
  yield takeEvery(actionTypes.UPDATE_RWAMEMBER_INIT_ACTION, updateRwaMember);
}
